import SauceCheeseFlavorStepDesktop from './SauceCheeseFlavorStepDesktop';

export default SauceCheeseFlavorStepDesktop;
